
<ion-content >
  <div *ngIf="platformSRV.isNative.value" class="add-margin-top-to-safe-area"></div>

  <ion-grid>
    <ion-row>
      <ion-col style="text-align: center;">
        <img src="assets/images/logo-banner.png">
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col >
        <swiper style="height: 100%;"
              #swiper
              (swiper)="setSwiperInstance($event)"
              [config]="config"
              (slideChange)="onSlideChange($event)">
              <ng-template swiperSlide >
                <ion-grid>
                  
                  <ion-row>
                    <ion-col style="text-align: center;">
                      <img src="assets/images/on_boarding_1.png">
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col  style="text-align: center;">
                      <h2 class="header-regular">Frictionless parking on an app.</h2>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="11" offset="0.5" style="text-align: center;"> 
                      <ion-label class="paragraph-regular">Pay for parking wherever you are.
                        <br>
                        <br>
                         Using the OPS-COM app you will be able to pay for your temporary parking or your term parking with a few taps on your phone.</ion-label>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ng-template>
              <ng-template swiperSlide >
                <ion-grid>
                  
                  <ion-row>
                    <ion-col style="text-align: center;">
                      <img src="assets/images/on_boarding_2.png">
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col style="text-align: center;">
                      <h2 class="header-regular">Temporary parking.</h2>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="11" offset="0.5" style="text-align: center;">
                      <ion-label class="paragraph-regular">Are you planning to purchase a temporary parking  permit, either for a few hours or a few days?
                        <br>
                        <br>
                        Quickly register your car using the app and pay for your parking session right away.</ion-label>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ng-template>
              <ng-template swiperSlide >
                <ion-grid>
                  
                  <ion-row>
                    <ion-col style="text-align: center;">
                      <img src="assets/images/on_boarding_3.png">
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col style="text-align: center;">
                      <h2 class="header-regular">Term parking.</h2>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="11" offset="0.5" style="text-align: center;">
                      <ion-label class="paragraph-regular">The OPS-COM app allows you to pay for your regular parking permits whether they are monthly, semester, or yearly permits.
                        <br>
                        <br>
                        A fully flexible tool for all your parking needs.</ion-label>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ng-template>
            </swiper>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="this.activeIndex<2">
      <ion-col  class="ion-no-padding">
        <ion-button  (click)="nextSlide()" expand="block" class="ionic_button" color="primary">Next</ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="this.activeIndex<2">
      <ion-col  class="ion-no-padding">
        <ion-button (click)="skipSlides()" fill="clear" expand="block" color="primary">Skip</ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="this.activeIndex==2">
      <ion-col  class="ion-no-padding">
        <ion-button  (click)="getStarted()" expand="block" class="ionic_button" color="primary">Get Started!</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
   
 
   
</ion-content>
